import { Button, Flex, Popconfirm } from "antd";

import { PrimaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";
import { useSW } from "@/hooks/useSW";

import { StyledInfoCircleOutlined, StyledUpdateBanner } from "./Styled";

const storeResetWarning =
    "Після оновлення поточний прогрес у додатку буде скинуто.";

export const UpdateBanner = () => {
    const { needRefresh, applyUpdate, storeReset } = useSW();
    const { offlineMode } = useAppSelector((s) => s.offline);

    if (!needRefresh) return null;

    return (
        <StyledUpdateBanner>
            <Flex gap={16} justify="space-between">
                <Flex gap={16} align="center">
                    <StyledInfoCircleOutlined />

                    <PrimaryText>Доступне оновлення додатку</PrimaryText>
                </Flex>

                <Popconfirm
                    title={
                        <Flex vertical gap={4}>
                            <PrimaryText lineHeight="22px">
                                Ви впевнені що готові оновити додаток?
                            </PrimaryText>

                            {needRefresh && storeReset && (
                                <PrimaryText $textColor="error">
                                    {storeResetWarning}
                                </PrimaryText>
                            )}
                        </Flex>
                    }
                    onConfirm={applyUpdate}
                    okText="Так"
                    cancelText="Ні"
                >
                    <Button type="primary" disabled={offlineMode}>
                        Оновити
                    </Button>
                </Popconfirm>
            </Flex>

            {needRefresh && storeReset && (
                <PrimaryText $textColor="error" fontSize={16} fontWeight="500">
                    {storeResetWarning}
                </PrimaryText>
            )}
        </StyledUpdateBanner>
    );
};
